<template>
  <div class="card card-chat-booking float-left ml-3">
    <div class="card-body">
      <!-- Display unavailable service areas for dust mite cleaning service -->
      <div v-if="experience && isDisabled">
        <div class="text-danger text-small">
          <i class="fas fa-exclamation-circle"></i> {{ $t('message.booking.checkout_step.service_provider_cannot_travel') }}
        </div>
        <div class="text-danger pb-3 text-small">
          {{ $t('message.booking.checkout_step.please_contact_admin') }} 
          <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank" class="text-primary-link">Line @BeNeat</a>
        </div>
        <button class="btn btn-block btn-outline-info btn-sm" @click="openUnavailableServiceAreaModal()">
          {{ $t('message.booking.checkout_step.view_more') }}
        </button>
        <hr>
      </div>

      <div class="mb-3">
        <b>{{ message.text }}</b>
      </div>
      <!-- Display recommended duration for cleaning service -->
      <div class="p-2" v-if="Number(bookingData.service_id) === 1 && bookingData.place_size_id">
        <div><b>{{ bookingData.place_name }}</b></div>
        <div>{{ $t(globalState.placeSizes[Number(bookingData.place_size_id)]) | multiLangName }}</div>
        <div class="text-primary">{{ $t('message.booking.booking_step.recommend') }}&nbsp;{{
          $t(globalState.durations[Number(bookingData.place_size_id)]) }}
        </div>
      </div>
      <!-- End display -->
      
      <!-- End display -->
      <div class="row no-gutters mt-2">
        <div class="col-4 p-1" v-for="button in message.buttons">
          <button class="btn btn-outline-info btn-block btn-small-group text-center"
                  :disabled="isDisabled"
                  @click="sendMessage(button)">{{ button.text }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    props: {
      message: Object
    },
    data () {
      return {
        isDisabled: false
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        experience: 'experience/getExperience'
      }),
      ...mapState('chatBooking', ['bookingData']),
      sortedPlaceSizes () {
        return this._.orderBy(this.globalState.placeSizes, ['id'], ['asc'])
      }
    },
    methods: {
      openUnavailableServiceAreaModal () {
        this.$parent.$parent.openUnavailableServiceAreaModal()
      },
      sendMessage (item) {
        const itemType = item.type
        switch (itemType) {
          case 'message':
            const message = {
              sender_type: 'user',
              type: 'text',
              label: item.label,
              text: item.text,
              data: item.data
            }
            this.$store.commit('chatBooking/ADD_MESSAGE', message)
            break
          case 'uri':
            window.open(item.uri, '_blank')
            break
        }
      }
    },
    async mounted () {
      // Check unavailable service areas of experience booking
      if (this.bookingData && Number(this.bookingData.service_id) === 15 && Number(this.bookingData.province_id) === 1) {
        const experienceId = 17
        await this.$store.dispatch('experience/LOAD_EXPERIENCE_DETAIL', experienceId)
        if (this.experience && this.experience.unavailable_service_area) {
          if (!this.bookingData.address_province_id || !this.bookingData.district_id) {
            this.isDisabled = true
          } else {
            const addressProvinceIds = this.experience.unavailable_service_area.address_provinces.map(province => {
              return province.id
            })
            const districtIds = this.experience.unavailable_service_area.districts.map(district => {
              return district.id
            })
            const userPlaceProvinceId = Number(this.bookingData.address_province_id)
            const userPlaceDistrictId = Number(this.bookingData.district_id)
            if (addressProvinceIds.includes(userPlaceProvinceId)) {
              this.isDisabled = true
            } else if (districtIds.includes(userPlaceDistrictId)) {
              this.isDisabled = true
            }
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chatBooking/components/ButtonsMessage.vue